import dataMixin from '@/mixins/data-mixin';

export default {
    props: {
        hideHeaderAppendOnReadonly: { type: Boolean, default: true }
    },
    computed: {
        readOnly() {
            return this.id && this._readOnly && !this.active;
        },
        showHeaderAppend() {
            if (this.hideHeaderAppendOnReadonly) { return !this._readOnly }
            return true;
        }
    },
    mixins: [
        dataMixin('_readOnly', 'transientData.readOnly'),
        dataMixin('active', self => `transientData.readOnly$${self.id || 'noId'}`)
    ],
    methods: {
        activate() {
            if (this._readOnly === false) return;
            this.active = true;
        }
    },
    watch: {
        _readOnly(val) {
            if (val) this.active = false;
        }
    }
}
